import React, { useState } from 'react';
import CompletionPopup from '../../completion-popup';
import { useCareerContext } from '../../career-context';

function Part3({ showAccuracy, displayModel, nextSlide }) {
    const {
        isPopupOpen,
        setIsPopupOpen,
        startConfetti
    } = useCareerContext(); 

    const [selectedModelIndex, setSelectedModelIndex] = useState(-1);
    const [selectedVarsIndex, setSelectedVarsIndex] = useState(-1);
    const [modelAccuracy, setModelAccuracy] = useState(null);
    const [readyToMoveOn, setReadyToMoveOn] = useState(false);

    function onModelSelect(index) {
        if ((index === 2 && selectedVarsIndex === 4) || (index === 4 && selectedModelIndex === 2)) {
            setIsPopupOpen(true);
            setReadyToMoveOn(true);
            // show success message and next button
            startConfetti();
        }
        if (index < 3) {
            displayModel(index, selectedVarsIndex);
            setModelAccuracy(showAccuracy(index, selectedVarsIndex));
            setSelectedModelIndex(index);
        } else {
            displayModel(selectedModelIndex, index);
            setModelAccuracy(showAccuracy(selectedModelIndex, index));
            setSelectedVarsIndex(index);

        }
    }


    function hidePopup() {
        setIsPopupOpen(false);
    }

    return (
        <div>
            {isPopupOpen && <CompletionPopup title="Correct!" message="Well done! Now we know polynomial regression fits our model the best, that customer demand is important when predicting EcoGreen's revenue." hidePopup={hidePopup}/>}
            <p>Find the best model for this dataset by playing with the model type and independent variable parameters. Remember, the better the model, the closer the accuracy will be to 100%.
            </p>
            <div className='model-container'>
                <div className='model-types-wrapper'>
                    <p style={{margin: 0}}>Model Type</p>
                    <div className='row'>
                        <button key={0} className={(selectedModelIndex === 0) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(0)}>Linear</button>
                        <button key={1} className={(selectedModelIndex === 1) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(1)}>Logarithmic</button>
                        <button key={2} className={(selectedModelIndex === 2) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(2)}>Polynomial</button>
                    </div>
                </div>
                <div className='independent-vars-wrapper'>
                    <p style={{margin: 0}}>Independent Variables</p>
                    <div className='row'>
                        <button key={3} className={(selectedVarsIndex === 3) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(3)}>Market Growth</button>
                        <button key={4} className={(selectedVarsIndex === 4) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(4)}>Customer Demand</button>
                        <button key={5} className={(selectedVarsIndex === 5) ? 'switch-btn selected' : 'switch-btn'} onClick={() => onModelSelect(5)}>Economic Conditions</button>
                    </div>
                </div>
            </div>
            {modelAccuracy && <p style={{textAlign:"center"}}><strong>Accuracy: {modelAccuracy}</strong></p>}
            {readyToMoveOn && <button className='primary-btn' onClick={nextSlide}>Next</button>}

        </div>
    )
}

export default Part3;